/* This file is autogenerated, see readme.md for instructions */
import ParagraphRightAlignSvgIcon from '@bloomreach/banana-theme/icons/paragraph-right-align.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ParagraphRightAlignIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ParagraphRightAlignSvgIcon />
    </Icon>
  );
});

ParagraphRightAlignIcon.displayName = 'ParagraphRightAlignIcon';

export default ParagraphRightAlignIcon;
